const BurgerMenuIcon = (props) => (
  <>
    <div className="hidden md:block">
      <svg
        width={34}
        height={34}
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4.25 7.4375H29.75C30.3308 7.4375 30.8125 6.95583 30.8125 6.375C30.8125 5.79417 30.3308 5.3125 29.75 5.3125H4.25C3.66917 5.3125 3.1875 5.79417 3.1875 6.375C3.1875 6.95583 3.66917 7.4375 4.25 7.4375Z"
          fill="currentColor"
        />
        <path
          d="M16.3342 14.5209H29.75C30.3308 14.5209 30.8125 14.0392 30.8125 13.4584C30.8125 12.8775 30.3308 12.3959 29.75 12.3959H16.3342C15.7533 12.3959 15.2717 12.8775 15.2717 13.4584C15.2717 14.0392 15.7392 14.5209 16.3342 14.5209Z"
          fill="currentColor"
        />
        <path
          d="M4.25 21.6041H29.75C30.3308 21.6041 30.8125 21.1225 30.8125 20.5416C30.8125 19.9608 30.3308 19.4791 29.75 19.4791H4.25C3.66917 19.4791 3.1875 19.9608 3.1875 20.5416C3.1875 21.1225 3.66917 21.6041 4.25 21.6041Z"
          fill="currentColor"
        />
        <path
          d="M16.3342 28.6875H29.75C30.3308 28.6875 30.8125 28.2058 30.8125 27.625C30.8125 27.0442 30.3308 26.5625 29.75 26.5625H16.3342C15.7533 26.5625 15.2717 27.0442 15.2717 27.625C15.2717 28.2058 15.7392 28.6875 16.3342 28.6875Z"
          fill="currentColor"
        />
      </svg>
    </div>
    <div className="block md:hidden">
      <svg
        width="19"
        height="12"
        viewBox="0 0 19 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M.73 2h17.54c.399 0 .73-.453.73-1s-.331-1-.73-1H.73C.332 0 0 .453 0 1s.331 1 .73 1"
          fill="url(#a)"
        />
        <path
          d="M1.299 7h16.402C18.411 7 19 6.547 19 6s-.589-1-1.299-1H1.299C.589 5 0 5.453 0 6s.572 1 1.299 1"
          fill="url(#b)"
        />
        <path
          d="M.73 12h17.54c.399 0 .73-.453.73-1s-.331-1-.73-1H.73c-.399 0-.73.453-.73 1s.331 1 .73 1"
          fill="url(#c)"
        />
        <defs>
          <linearGradient
            id="a"
            x1="9.5"
            y1="0"
            x2="9.5"
            y2="2"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              stopColor={
                process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#4064AA"
              }
            />
            <stop
              offset="1"
              stopColor={
                process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#8A3A85"
              }
            />
          </linearGradient>
          <linearGradient
            id="b"
            x1="9.5"
            y1="5"
            x2="9.5"
            y2="7"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              stopColor={
                process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#4064AA"
              }
            />
            <stop
              offset="1"
              stopColor={
                process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#8A3A85"
              }
            />
          </linearGradient>
          <linearGradient
            id="c"
            x1="9.5"
            y1="10"
            x2="9.5"
            y2="12"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              stopColor={
                process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#4064AA"
              }
            />
            <stop
              offset="1"
              stopColor={
                process.env.NEXT_PUBLIC_CUSTOM_COLOR ? "#00343a" : "#8A3A85"
              }
            />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </>
);
export default BurgerMenuIcon;
